import React, { useState } from "react";
import { utils } from "../../../utils/utils";
import { Container, Button } from "reactstrap";
import ProgrammingTable from "./ProgrammingTable";
import InformationModal from "../../InformationModal";
import ConfirmationModal from "../../ConfirmationModal";
import ProgrammingDetailsModal from "./ProgrammingDetailsModal";
import { programmingApi } from "../../../services/programmingServices";

const PROGRAMMING_STATUS = 3;
const WAITING_FOR_CHECK_STATUS = 4;
const PROGRAMMING_TAB = "PROGRAMMING_TAB";

const Programming = ({
  programmingTotal,
  setProgrammingTotal,
  setReloadTabs,
  reloadTabs,
  tabName,
}) => {
  const [programmingStatusId, setProgrammingStatusId] = useState();
  const [programmingSelected, setProgrammingSelected] = useState();
  const [detailModal, setDetailModal] = useState(false);
  const [informationModal, setInformationModal] = useState(
    utils.initInformationModal
  );
  const [confirmationModal, setConfirmationModal] = useState(
    utils.initConfirmationModal
  );

  const columns = [
    {
      accessor: "completeStatus",
      Header: "",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 120,
      Cell: (rowData) => {
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"success"}
            onClick={() => {
              changeProgrammingStatus(
                rowData.row.original,
                WAITING_FOR_CHECK_STATUS
              );
            }}
          >
            Send to Checker
          </Button>
        );
      },
    },
    {
      accessor: "seeJobDetailsButton",
      Header: "Job Details",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 125,
      Cell: (rowData) => {
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"primary"}
            onClick={() => {
              const programming = rowData.row.original;
              setProgrammingSelected(programming);
              setProgrammingStatusId(programming.programmingStatusId);
              setDetailModal(true);
            }}
          >
            See Job Details
          </Button>
        );
      },
    },
  ];

  const onClear = async () => {
    setConfirmationModal(utils.initConfirmationModal);
    setInformationModal(utils.initInformationModal);
    setDetailModal(false);
    setProgrammingSelected();
    setProgrammingStatusId();
  };

  const changeProgrammingStatus = async (programming, programmingStatusId) => {
    try {
      const sendToChecker = programmingStatusId === WAITING_FOR_CHECK_STATUS;
      setConfirmationModal({
        isOpen: true,
        onSubmit: async () => {
          try {
            await programmingApi.updateProgramming(programming.id, {
              ...programming,
              programmingStatusId,
            });
            onClear();
            setInformationModal({
              isOpen: true,
              title: sendToChecker ? "Send to Checker" : "Programming Update",
              body: sendToChecker
                ? "Programming sent to checker successfully."
                : "Programming updated successfully.",
            });
            setReloadTabs([
              PROGRAMMING_TAB,
              utils.programmingTabs[programmingStatusId],
            ]);
          } catch (error) {
            onClear();
            setInformationModal({
              isOpen: true,
              title: "Error",
              body: "There was an error with your request.",
            });
          }
        },
        onClose: () => setConfirmationModal(utils.initConfirmationModal),
        title: sendToChecker ? "Send to Checker" : "Programming Update",
        body: sendToChecker
          ? `
          <div class="text-center">
            Are you sure you are ready to send this job to the ${
              programming.checker
                ? `${programming.checker.firstName} ${programming.checker.lastName}`
                : "Checker assigned"
            } for Checking?
          </div>
        `
          : `
        <div class="text-center">
          Do you confirm you want to update the job ${programming.job.jobNumber}?
        </div>
      `,
        confirmColor: "warning",
      });
    } catch (error) {
      setInformationModal({
        isOpen: true,
        title: "Error",
        body: "There was an error with your request.",
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    changeProgrammingStatus(programmingSelected, programmingStatusId);
  };

  return (
    <Container fluid className="px-0">
      <ProgrammingTable
        columns={columns}
        programmingStatusId={PROGRAMMING_STATUS}
        setProgrammingTotal={setProgrammingTotal}
        programmingTotal={programmingTotal}
        reloadTabs={reloadTabs}
        tabName={tabName}
      />
      {informationModal.isOpen ? (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={() => setInformationModal(utils.initInformationModal)}
        />
      ) : confirmationModal.isOpen ? (
        <ConfirmationModal {...confirmationModal} />
      ) : detailModal ? (
        <ProgrammingDetailsModal
          programming={programmingSelected}
          detailModal={detailModal}
          onSubmit={onSubmit}
          onClear={onClear}
          readOnly={true}
          enableUpdate={true}
          statusId={programmingStatusId}
          setStatusId={setProgrammingStatusId}
        />
      ) : null}
    </Container>
  );
};

export default Programming;
